// TELEMETRY
export const telemetryFilesUrl = 'report/telemetry/file/';
export const telemetryReportFileUrl = (reportId: string) => `report/telemetry/file/${reportId}/`;
export const telemetryReportUrl = (assetId: string) => `report/telemetry/asset/${assetId}/`;
export const telemetryByGroupReportUrl = (groupId: string) => `report/telemetry/group/${groupId}/`;
// HISTORIC STATE
export const historicStateFilesUrl = 'report/historic-state/file/';
export const historicStateReportFileUrl = (reportId: string) => `report/historic-state/file/${reportId}/`;
export const historicStateReportUrl = (assetId: string) => `report/historic-state/asset/${assetId}/`;
export const historicStateByGroupReportUrl = (groupId: string) => `report/historic-state/group/${groupId}/`;
// PATHS
export const pathsFilesUrl = 'report/paths/file/';
export const pathsReportFileUrl = (reportId: string) => `report/paths/file/${reportId}/`;
export const pathsReportUrl = (assetId: string) => `report/paths/asset/${assetId}/`;
export const pathsByGroupReportUrl = (groupId: string) => `report/paths/group/${groupId}/`;
export const pathUrl = (pathId: string) => `report/paths/${pathId}/`;
// CONSUMPTION
export const consumptionFilesUrl = 'report/consumption-media/file/';
export const consumptionReportFileUrl = (reportId: string) => `report/consumption-media/file/${reportId}/`;
export const consumptionReportUrl = 'report/consumption-media/';
// DOOR
export const doorStateReportFilesUrl = 'report/delivery-fence/file/';
export const doorStateReportFileUrl = (reportId: string) => `report/delivery-fence/file/${reportId}/`;
export const doorStateReportUrl = (assetId: string) => `report/delivery-fence/asset/${assetId}/`;
export const doorStateByGroupReportUrl = (groupId: string) => `report/delivery-fence/group/${groupId}/`;
// DELIVERY
export const deliveryReportFilesUrl = 'report/delivery-fence-events/file/';
export const deliveryReportFileUrl = (reportId: string) => `report/delivery-fence-events/file/${reportId}/`;
// HISTORIC EVIDENCES
export const historicEvidenceReportUrl = (assetId: string) => `report/historic-evidence/asset/${assetId}/`;
export const historicEvidenceByGroupReportUrl = (groupId: string) => `report/historic-evidence/group/${groupId}/`;
export const historicEvidenceUrl = (evidenceId: string) => `report/historic-evidence/evidences/${evidenceId}/`;
export const historicEvidenceFilesUrl = 'report/historic-evidence/file/';
export const historicEvidencesReportFileUrl = (reportId: string) => `report/historic-evidence/file/${reportId}/`;
// HICTORIC ALARMS
export const historicAlarmsFilesUrl = 'report/historic-alarms/file/';
export const historicAlarmsReportFileUrl = (reportId: string) => `report/historic-alarms/file/${reportId}/`;
export const historicAlarmsReportUrl = (assetId: string) => `report/historic-alarms/asset/${assetId}/`;
export const historicAlarmsByGroupReportUrl = (groupId: string) => `report/historic-alarms/group/${groupId}/`;
